const CONSENT_KEY = "pep.analytics.consent";

export type AnalyticsConsent = "granted" | "denied" | "pending";

export function getAnalyticsConsent(): AnalyticsConsent {
  const v = localStorage.getItem(CONSENT_KEY);
  if (v === "granted" || v === "denied") return v;
  return "pending";
}

export function setAnalyticsConsent(value: "granted" | "denied") {
  localStorage.setItem(CONSENT_KEY, value);
}

export function shouldTrack(): boolean {
  if (navigator.doNotTrack === "1") return false;
  return getAnalyticsConsent() === "granted";
}

export async function trackPageView(path: string) {
  if (!shouldTrack()) return;
  try {
    await fetch("/api/pep/analytics/pageview", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path, ts: new Date().toISOString() }),
      keepalive: true,
    });
  } catch {
    // silent — analytics must not break UX
  }
}

export async function trackEvent(name: string, payload?: Record<string, unknown>) {
  if (!shouldTrack()) return;
  try {
    await fetch("/api/pep/analytics/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name,
        payload: payload ?? {},
        ts: new Date().toISOString(),
      }),
      keepalive: true,
    });
  } catch {
    // silent — analytics must not break UX
  }
}
